import React from 'react';
import { withRouter } from 'react-router';
import DropDownMaker from './subcomponents/DropDownMaker';
import styles from '../statics/styles';
import '../statics/stylesheet.css';

const getObjectValue = (arr) => {
  const tempArray = [];
  for (let i = 0; i < arr.length; i++) {
    tempArray.push(arr[i]);
  }
  return tempArray;
};

class SizeSelectionTires extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      staggeredSearch: false,
      checked: true
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleButtonClick = (key) => {
    const tireSize = JSON.parse(window.localStorage.getItem('hdata'));
    const { router } = this.props;
    router.push('/Tires/Size/' + tireSize[key].replace('/', '-'));
  }

  getSizes() {
    const data = require('../utils/tiresize.json');
    if (this.state.tire_size_dropdown) {
      return;
    }

    const treadWidthsData = getObjectValue(data.tread_widths);
    const wheelProfilesData = getObjectValue(data.wheel_profiles);
    const wheelSizesData = getObjectValue(data.wheel_sizes);
    this.setState({ loading: false, treadWidths: treadWidthsData, wheelProfiles: wheelProfilesData, wheelSizes: wheelSizesData });
  }

  fromStyle() {
    if (this.props.inSizes) {
      return 'content-inSizesStyle';
    }
    return 'content-divLength';
  }

  componentWillMount() {
    this.getSizes();
    this.setState({ style: this.fromStyle() });
    if (window.sessionStorage.getItem('staggered') == 'true') {this.setState({ staggeredSearch: true });}
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { router } = this.context;
    const { loading, staggeredSearch } = this.state;
    const { category, search_by } = this.props.params;
    window.localStorage.removeItem('performance tire');

    const tireSize = JSON.parse(window.localStorage.getItem('hdata'));
    const stireSize = JSON.parse(window.localStorage.getItem('hdata2'));
    const wheelsize = window.localStorage.getItem('wheelsizeselected');
    const wheels_status = window.localStorage.getItem('wheels_status');

   
    return (
      <div className={this.state.style}>

        {navigator.userAgent.toLowerCase().indexOf('chrome') > -1 || navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ?
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.svg'} />
          </div> :
          loading &&
          <div className="sizeSelection-loading">
            <img src={window.host + '/statics/img/loading.gif'} />
          </div>
        }

        <div className="sizeSelection-sizeContainer">
        <h2 className="content-titleFont">Suggested Tire Sizes:</h2>
        <br/>

        { wheels_status === 'Non-Staggered' &&
        <div className="size-oemContainer_mainhead" style={{ textAlign: 'center', width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>

          {Object.keys(tireSize).map((key, i) =>
            <p key={i}>
              { key.indexOf('OP') > -1 && key.indexOf(wheelsize) > -1 &&
              <button className="size-oemContainer__btn tire_size_label" 
              onClick={() => {
                const sizeParts = tireSize[key].split('-');
                const treadwidth =  sizeParts[0].split('/')[0]; 
                const wheelprofile = sizeParts[0].split('/')[1]; 
                const wheelsize = sizeParts[1];
                this.goToURL(category, search_by, treadwidth, wheelprofile, wheelsize, router);
              }}>
                    <span><span className="size-oemContainer__btn_size">{wheelsize}"</span>
                    <span className="size-oemContainer__btn_value" style={{width: '40%'}}>{tireSize[key]} <small>Front and Rear</small></span>
                    <span className="size-oemContainer__btn_carot">{'>'}</span></span>
              </button>}
            </p>
          )}

         {Object.keys(tireSize).map((key, i) =>
        <p key={i}>
          { key.indexOf('OE') > -1 && key.indexOf(wheelsize) > -1 &&
          <button className="size-oemContainer__btn tire_size_label"
         onClick={() => {
          
          const sizeParts = tireSize[key].split('-');
          const treadwidth =  sizeParts[0].split('/')[0]; 
          const wheelprofile = sizeParts[0].split('/')[1]; 
          const wheelsize = sizeParts[1];
          
          this.goToURL(category, search_by, treadwidth, wheelprofile, wheelsize, router);
        }}>
              <span><span className="size-oemContainer__btn_size">{wheelsize}"</span>
              <span className="size-oemContainer__btn_value" style={{width: '40%'}}>{tireSize[key]} <small>Front and Rear</small></span>
              <span className="size-oemContainer__btn_carot">{'>'}</span></span>
          </button>}
        </p>
        )}

       {Object.keys(tireSize).map((key, i) =>
        <p key={i}>
          { key.indexOf('PLUS') > -1 && key.indexOf(wheelsize) > -1 &&
          <button className="size-oemContainer__btn tire_size_label" 
          onClick={() => {
          
            const sizeParts = tireSize[key].split('-');
            const treadwidth =  sizeParts[0].split('/')[0]; 
            const wheelprofile = sizeParts[0].split('/')[1]; 
            const wheelsize = sizeParts[1];
            
            this.goToURL(category, search_by, treadwidth, wheelprofile, wheelsize, router);
          }}>
                 <span><span className="size-oemContainer__btn_size">{wheelsize}"</span>
                 <span className="size-oemContainer__btn_value" style={{width: '40%'}}>{tireSize[key]} <small>Front and Rear</small></span>
                 <span className="size-oemContainer__btn_carot">{'>'}</span></span>
          </button>}
        </p>
        )}
        </div>
         }   

   { wheels_status === 'Staggered' &&
      <div className="size-oemContainer_mainhead" 
        style={{ textAlign: 'center', width: '100%', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>

          {Object.keys(stireSize).map((key, i) =>
            <p key={i}>
              { key.indexOf('OP') > -1 && key.indexOf(wheelsize) > -1 &&
              <button className="size-oemContainer__btn tire_size_label" 
                onClick={() => {
                  const front = stireSize[key].Front.split('/');
                  const rear = stireSize[key].Rear.split('/');
                  
                  const treadwidthfront = front[0];
                  const wheelprofilefront = front[1].split('-')[0];
                  const wheelsizefront = front[1].split('-')[1];
                  
                  const treadwidthrear = rear[0];
                  const wheelprofilerear = rear[1].split('-')[0];
                  const wheelsizerear = rear[1].split('-')[1];
                  
                  this.goToStaggeredURL(category, search_by, treadwidthfront, wheelprofilefront, wheelsizefront, treadwidthrear, wheelprofilerear, wheelsizerear, router);
                }}>
                    <span>
                      <span className="size-oemContainer__btn_size">{wheelsize}"</span>
                      <span className="size-oemContainer__btn_value" style={{width: '26%'}}>{stireSize[key].Front} <small>Front</small></span>
                      <span className="size-oemContainer__btn_value" style={{width: '26%'}}>{stireSize[key].Rear} <small>Rear</small></span>
                      <span className="size-oemContainer__btn_carot">{'>'}</span>
                    </span>
              </button>}
            </p>
          )}

          {Object.keys(stireSize).map((key, i) =>
            <p key={i}>
              { key.indexOf('OE') > -1 && key.indexOf(wheelsize) > -1 &&
              <button className="size-oemContainer__btn tire_size_label" 
                onClick={() => {
                  const front = stireSize[key].Front.split('/');
                  const rear = stireSize[key].Rear.split('/');
                  
                  const treadwidthfront = front[0];
                  const wheelprofilefront = front[1].split('-')[0];
                  const wheelsizefront = front[1].split('-')[1];
                  
                  const treadwidthrear = rear[0];
                  const wheelprofilerear = rear[1].split('-')[0];
                  const wheelsizerear = rear[1].split('-')[1];
                  
                  this.goToStaggeredURL(category, search_by, treadwidthfront, wheelprofilefront, wheelsizefront, treadwidthrear, wheelprofilerear, wheelsizerear, router);
                }}>
                    <span>
                      <span className="size-oemContainer__btn_size">{wheelsize}"</span>
                      <span className="size-oemContainer__btn_value" style={{width: '26%'}}>{stireSize[key].Front} <small>Front</small></span>
                      <span className="size-oemContainer__btn_value" style={{width: '26%'}}>{stireSize[key].Rear} <small>Rear</small></span>
                      <span className="size-oemContainer__btn_carot">{'>'}</span>
                    </span>
              </button>}
            </p>
          )}
        </div>
    }
        <br/>

          <h2 className="content-titleFont">Search Tires by size: </h2>
          <div style={{ textAlign: ' center' }} />
          {wheels_status === 'Staggered' ? <DropDownMaker
            buttonlist={[
              { id: 'tread_width_front', name: 'Tread Width Front', options: this.state.treadWidths },
              { id: 'wheel_profile_front', name: 'Tire Profile Front', options: this.state.wheelProfiles },
              { id: 'wheel_size_front', name: 'Wheel Size Front', options: this.state.wheelSizes },
              { type: 'separator' },
              { id: 'tread_width_rear', name: 'Tread Width Rear', options: this.state.treadWidths },
              { id: 'wheel_profile_rear', name: 'Tire Profile Rear', options: this.state.wheelProfiles },
              { id: 'wheel_size_rear', name: 'Wheel Size Rear', options: this.state.wheelSizes }
            ]}
            btnStyle={styles.shoppingMethodButtonWithMargin}
            submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
            whenClicked={(options) =>
              this.goToStaggeredURL(category, search_by, options.tread_width_front, options.wheel_profile_front, options.wheel_size_front, options.tread_width_rear, options.wheel_profile_rear, options.wheel_size_rear, router)
            }
          /> : <div>
            <br/><DropDownMaker
              buttonlist={[
                { id: 'tread_width', name: 'Tread Width', options: this.state.treadWidths },
                { id: 'wheel_profile', name: 'Tire Profile', options: this.state.wheelProfiles },
                { id: 'wheel_size', name: 'Wheel Size', options: this.state.wheelSizes }
              ]}
              btnStyle={styles.shoppingMethodButtonWithMargin}
              sizeFilled={window.sessionStorage.getItem('treadWidth') !== null && window.sessionStorage.getItem('tireProfile') && window.sessionStorage.getItem('wheelSizes')}
              submitButton={{ name: 'Go!', classname: 'btn btn-primary' }}
              whenClicked={(options) => this.goToURL(category, search_by, options.tread_width, options.wheel_profile, options.wheel_size, router)
              }

          /></div>}
        </div>
      </div>
    );
  }

  goToURL(category, searchBy, treadwidth, wheelprofile, wheelsize, router) {
      const vehicle = this.props.params.options.split(' ').join('%20');
     router.push('/Tires/' + 'Size' + '/' + treadwidth + '-' + wheelprofile + '-' + wheelsize);
     window.location.href = 'http://localhost:8080/Tires/Size/' + treadwidth + '-' + wheelprofile + '-' + wheelsize;
      window.location.reload();
  }

  goToStaggeredURL(category, searchBy, treadwidthfront, wheelprofilefront, wheelsizefront, treadwidthrear, wheelprofilerear, wheelsizerear, router) {
    const url = '/Tires/Size/' + treadwidthfront + '-' + wheelprofilefront + '-' + wheelsizefront + '-' + treadwidthrear + '-' + wheelprofilerear + '-' + wheelsizerear;
    
    router.push(url);
    window.location.href = 'http://soratwheels.ca' + url;
    window.location.reload();
  }
}

SizeSelectionTires.propTypes = {
  params: React.PropTypes.object.isRequired
};

SizeSelectionTires.contextTypes = {
  router: React.PropTypes.object.isRequired
};
export default withRouter(SizeSelectionTires);

//11


// WEBPACK FOOTER //
// ./src/components/SizeSelectionTires.js